import { UrlProvider } from "../api/UrlProvider";

export default class PageHelper {
  static getIsRegisterPage(location, locale) {
    return location.pathname === UrlProvider.getUrl("fe.register", { locale });
  }

  static getIsLoginOtpPage(location, locale) {
    return location.pathname === UrlProvider.getUrl("fe.loginOtp", { locale });
  }

  static getIsLoginPage(location, locale) {
    return location.pathname === UrlProvider.getUrl("fe.login", { locale });
  }

  static getIsForgotPasswordPage(location, locale) {
    return (
      location.pathname === UrlProvider.getUrl("fe.resetPassword", { locale })
    );
  }

  static getIsResetPasswordExecutePage(location, locale) {
    const loginPath = UrlProvider.getUrl("fe.login", { locale });

    return location.pathname.startsWith(`${loginPath}/reset-password/`);
  }

  static getIsAuthPage(location, locale) {
    return (
      PageHelper.getIsLoginPage(location, locale) ||
      PageHelper.getIsLoginOtpPage(location, locale) ||
      PageHelper.getIsRegisterPage(location, locale) ||
      PageHelper.getIsForgotPasswordPage(location, locale) ||
      PageHelper.getIsResetPasswordExecutePage(location, locale)
    );
  }

  static getIsPaymentPage(location, locale) {
    return location.pathname.startsWith(
      UrlProvider.getUrl("fe.paymentDetails", { locale })
    );
  }

  static getIsOfferCheckoutPage(location, locale) {
    const localizedBase = UrlProvider.getLocalizedUrl(locale, "fe.offerCheckout", {
      locale,
      offerId: ""
    });
    const defaultBase = UrlProvider.getUrl("fe.offerCheckout", {
      locale,
      offerId: ""
    });
    return (
      location.pathname.startsWith(localizedBase) ||
      location.pathname.startsWith(defaultBase)
    );
  }

  static getIsHomePage(location, locale) {
    return (
      location.pathname === UrlProvider.getUrl("fe.home") ||
      location.pathname === UrlProvider.getUrl("fe.homeWithLocale", { locale })
    );
  }

  static getIsLandingPage(location) {
    return location.pathname.indexOf("/l/") === 0;
  }
}
